import { Component, ElementRef, Injectable, ViewChild } from '@angular/core';
import { ApiService } from './@theme/service';
import { UtilityService } from './@theme/service/utility.service';
import 'jspdf-autotable';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  getServertime: any;

  constructor(public utility: UtilityService, public api: ApiService, private bnIdle: BnNgIdleService, public router: Router,
    public http: HttpClient,
    private _elementRef: ElementRef){
      // this.getMessage();
      this.getTokenFirst();
    // this.utility.setinitialAppLanguage();
  }

  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute("ng-version");
}

async getTokenFirst(){
  await this.http.get<any>(`${environment.endpoint}/getdate`, { headers: this.getHeaders('/getdate')}).subscribe(async (res:any) => {
    this.getServertime = res.map._date;
    await this.getuserNamePassword();
    //   const obj ={
    //   username:this.api.encrypt('flexicode',res.map._date),
    //   password:this.api.encrypt('password',res.map._date)
    // }
    // await this.http.post<any>(`${environment.endpoint}/authenticate`, obj, { headers: this.getHeaders('/authenticate')}).subscribe(async (res:any) =>{
    //   localStorage.setItem(`token`, res.token);
    //   await this.getMessage();
    // })
  })
}

getuserNamePassword(){
  this.http.get(`${environment.endpoint}/${'getJwt'}`, {headers: this.getHeaders('/getJwt')}).subscribe(async (res:any) =>{
   if(res) {
     const username = this.api.decrypt(res.username).split("~");
     const pswd = this.api.decrypt(res.password).split("~");
    //  console.log(`username`, username[0]);
    //   console.log(`pswd`, pswd[0])
     const obj = {
      username : username[0],
      password : pswd[0]
     }
     await this.http.get<any>(`${environment.endpoint}/getdate`, { headers: this.getHeaders('/getdate')}).subscribe(async (res:any) => {
      this.getServertime = res.map._date;
     const obj1 = {
       username:this.api.encrypt(obj.username,this.getServertime),
       password:this.api.encrypt(obj.password,this.getServertime)
     }
     // const obj ={
     //   username:this.api.encrypt(this.username,this.getServertime),
     //   password:this.api.encrypt(this.pwd,this.getServertime)
     // }
    //  console.log(`obj`, obj);
     this.api.getToken(`/authenticate`, obj1).subscribe(async (res:any) =>{
       localStorage.setItem(`token`, res.token);
       await this.getMessage();
     })
    });
    //  console.log(`obj1 return`, obj);
    //  return obj;
   }
  })
}

getHeaders(url) {
  let headerValue = {};
  const token = localStorage.getItem(`token`);
  if(url != "/getdate"){
    headerValue =  {
      'Content-Type':  'application/json',
      'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
      'X-Tenant-Identifier': 'dynamic_lokos',
      'Authorization': (token || token != 'undefined' || token != null) ? 'Bearer ' + token: '',
      'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0',
      // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
      // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
      // "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      // "X-XSS-Protection": "1; mode=block",
      '_url': url,
      '_user_token': '',
      'userCode': '',
      'roleCode': '',
      'blockCode': '',
      'statusCode':'',
    }
  }else{
    headerValue =  {
      'Content-Type':  'application/json',
      'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
      'X-Tenant-Identifier': 'dynamic_lokos',
      //'Authorization': (token || token != 'undefined' || token != null) ? 'Bearer ' + token: '',
      'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0',
      // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
      // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
      // "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      // "X-XSS-Protection": "1; mode=block",
      '_url': url,
      '_user_token': '',
      'userCode': '',
      'roleCode': '',
      'blockCode': '',
      'statusCode':'',
    }
  }
    
    return new HttpHeaders(headerValue);
  }
  
  // ngOnInit(): void {
  //   this.bnIdle.startWatching(10).subscribe((isTimedOut: boolean) => {
  //     if (isTimedOut) {
  //       this.utility.toaster('Error', 'Session Expired')
  //       this.bnIdle.stopTimer();
  //       setTimeout(() => {
  //         localStorage.clear();
  //         sessionStorage.clear();
  //         this.router.navigateByUrl('/auth');
  //       }, 1000);
  //     }
  //   });
  // }


  getMessage(){
    const reqHeader = {
      "_user_code": "",
      "_user_token": "",
      "_url": '/getMessagedesclist',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers: this.getHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
          if (res) {
            this.api.get(`${`/getMessagedesclist?`}@${res.myArrayList[0].map._user_token}`).subscribe(res => {
              const WebMessage = res[0].filter(item => item.msg_code.charAt(1) == 'W');
              localStorage.setItem(`WebMessage`, JSON.stringify(WebMessage));
            });
          }
        });
  }
  
}
